import DownloadIcon from '@mui/icons-material/Download';
import { Box, Tooltip, useTheme } from '@mui/material';
import exportFromJSON from 'export-from-json';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { useGetCurrOnboardBlock } from '../hooks/useGetCurrOnboardBlock';

const DownloadBlockBoundaryButton: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { currentData: block } = useGetCurrOnboardBlock();

  const handleDownload = () => {
    if (!block || !block?.geoPolygon) {
      alert('Block not found, select a block to download.');
      return;
    }

    exportFromJSON({
      data: block?.geoPolygon || {},
      fileName: block?.name || 'Block Boundary',
      extension: 'geojson',
      exportType: 'json',
    });
  };

  return (
    <Tooltip
      title={t('Download block boundary for editing. Reupload after editing.')}
      placement='top'
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: theme.colors.darkTheme.grey.medium,
          color: theme.colors.common.white,
          borderRadius: theme.borderRadius.primary,
          p: '0.6rem',
          cursor: 'pointer',
        }}
        onClick={handleDownload}
      >
        {<DownloadIcon />}
      </Box>
    </Tooltip>
  );
};

export default DownloadBlockBoundaryButton;
